import { NotificationSenderLayout } from "../NotificationSenderLayout";
import { NSARouterMakerResult, NSAVerificationPage } from "namirasoft-account-react";
import { NotificationSenderProps } from "../NotificationSenderProps";
import { useParams } from "react-router-dom";
import { NotificationSenderRoutes } from "../NotificationSenderRoutes";
import { useEffect, useState } from "react";
import { SubscriberRow } from "namirasoft-notification-sender";
import { NSLoading } from "namirasoft-site-react";

export interface VerifySubscriberPageProps extends NSARouterMakerResult, NotificationSenderProps
{ }
export interface VerifySubscriberPageState
{
	subscriber: SubscriberRow | null;
}

export default function VerifySubscriberPage(props: VerifySubscriberPageProps)
{
	let { subscriber_id } = useParams();
	let [state, setState] = useState<VerifySubscriberPageState>({ subscriber: null });

	useEffect(() =>
	{
		if (subscriber_id)
			props.servers.notification_sender.subscriber.Get(subscriber_id).then(subscriber =>
			{
				setState({ subscriber });
			}).catch(() => { });
		// eslint-disable-next-line
	}, [subscriber_id]);

	if (!state.subscriber)
        return (
            <NotificationSenderLayout {...props}>
                <NSLoading />
            </NotificationSenderLayout>
        );

	return (
		<NotificationSenderLayout {...props}
			action={{
				title: "Verify Subscriber",
				description: "Enter the verification code sent to you to confirm your request and activate the service.",
				menus: {}
			}}
		>
			<NSAVerificationPage
				{...props}
				contact_type={state.subscriber.sender_type}
				contact_value_name={"Message to"}
				getContactValue={(_: boolean) =>
				{
					return state.subscriber?.value ?? "";
				}}
				onRequest={async () =>
				{
					if (subscriber_id)
						await props.servers.notification_sender.subscriber.Request(subscriber_id);
				}}
				onVerify={async code =>
				{
                    if (subscriber_id)
                        await props.servers.notification_sender.subscriber.Verify(
                            subscriber_id,
                            { code }, {
                            onError: (error: Error) => props.notifier.onError(error),
                        });
				}}
				onFinished={() =>
				{
					if (subscriber_id)
						props.url.redirect(NotificationSenderRoutes.SubscriberView(subscriber_id), {});
				}}
			>
			</NSAVerificationPage>
		</NotificationSenderLayout>
	);
};